// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"144":"da8780eb","348":"b9561c6c","436":"815aa537","761":"3b78b013"}[chunkId] + ".chunk.css";
};